// extracted by css-extract-rspack-plugin
var _1 = "style-module__active--hZM5v";
var _2 = "style-module__avatar-container--X8ruR";
var _3 = "style-module__burger-block--O3mYA";
var _4 = "style-module__container--qe4hA";
var _5 = "style-module__content-block--KIUnF";
var _6 = "style-module__fullscreen-toggle-container--OxSSB";
var _7 = "style-module__header-portal--shgKx";
var _8 = "style-module__login--E0pNB";
var _9 = "style-module__login-block--nucTn";
var _a = "style-module__logo--Gyfny";
var _b = "style-module__logo-block--lnNaK";
var _c = "style-module__title--m6Lrs";
var _d = "style-module__user-block--ayRYb";
var _e = "style-module__whiteswan--nnhKl";
export { _1 as "active", _2 as "avatar-container", _3 as "burger-block", _4 as "container", _5 as "content-block", _6 as "fullscreen-toggle-container", _7 as "header-portal", _8 as "login", _9 as "login-block", _a as "logo", _b as "logo-block", _c as "title", _d as "user-block", _e as "whiteswan" }
